import { httpClient } from 'Shared/network';
import { QUERY_KEY } from '@constants';
import type { GetBanksOkDto } from 'viewup-api';

export const getBanks = async (): Promise<GetBanksOkDto> => {
  const { data } = await httpClient.get<GetBanksOkDto>(QUERY_KEY.BANK);
  return data;
};
